export class TagForm {
    form = {
        "submitButton": true,
        "blocks": [
            {
                "name": "basic_information",
                "class_name": "null",
                "order": 1,
                "fields": [
                    {
                        "class_name": "col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 fix",
                        "order": 3,
                        "type": "COMPOSITE-ARRAY",
                        "component": "tag_mapping",
                        "name": "attributes",
                        "item_key": "key_name"
                    }
                ]
            }
        ]
    }
}
